import script from "./AboutUsEN.vue?vue&type=script&setup=true&name=AboutUs&lang=js"
export * from "./AboutUsEN.vue?vue&type=script&setup=true&name=AboutUs&lang=js"

import "./AboutUsEN.vue?vue&type=style&index=0&id=6e7ed409&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e7ed409"]])

export default __exports__